/** @file crossTo: the unit cross product of two 3-vectors scaled, written into a scratch vector. */
import type { V3 } from './matrixRows';

/** `out = unit(u x v) x s`, or `(s, 0, 0)` when they are parallel. Allocates nothing. */
export function crossTo(out: V3, u: V3, v: V3, s: number): void {
  const x = u[1] * v[2] - u[2] * v[1];
  const y = u[2] * v[0] - u[0] * v[2];
  const z = u[0] * v[1] - u[1] * v[0];
  const n = Math.hypot(x, y, z);
  if (n < 1e-12) { out[0] = s; out[1] = 0; out[2] = 0; return; }
  out[0] = (x / n) * s; out[1] = (y / n) * s; out[2] = (z / n) * s;
}
